import { Component, Renderer2,ElementRef, OnInit, Inject } from '@angular/core';
import {DataService} from '../../shared/services/data.service';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ApiServices} from '../../shared/services/api.service';
import {Subscription} from 'rxjs';
import {Order, OrderResponse} from '../../shared/models/OrderResponse';
import {ToastrService} from 'ngx-toastr';
import {Title} from '@angular/platform-browser';
import {MetaService} from '../../shared/services/meta.service';
import { DOCUMENT } from '@angular/common';
import * as $ from 'jquery';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent implements OnInit {

  orderSubscription: Subscription;
  orderData: Order;
  orderId: any;

  constructor(
    private dataService: DataService,
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiServices,
    private toastr: ToastrService, private metaService: MetaService,
    private pTitle: Title,
    private _renderer2: Renderer2, 
    private elRef: ElementRef,
    @Inject(DOCUMENT) private _document: Document
  ) {
    route.queryParams.subscribe((params: Params) => {
      if (params && params.order_id) {
        this.getOrder(params.order_id);
        this.orderId = params.order_id;
        // this.sendFbPurchaseEvent();
      }
    });
    this.pTitle.setTitle(route.snapshot.data.title);

  }

  ngOnInit(): void {
    // this.dataService.hideHeaderFooter.next(true);
    // this.metaService.updateCanonicalURL();
  }


  getOrder(orderId: any): void {
    this.orderSubscription = this.apiService.getOrderById(orderId).subscribe(
      response => {
        this.orderData = response.data;
        // console.log([this.orderData]);
        if(this.orderData.status == 1 || this.orderData.status == 5 ){
          this.addTagManagerScript();
        }
      }, error => {
        this.toastr.error(error.error.message, 'Error');
        this.router.navigateByUrl('/');
      }
    );
  }

  sendFbPurchaseEvent(): void{
    this.apiService.sendFbPurchaseEvent(this.orderId).subscribe();
  }

  addTagManagerScript():void {
    let totalItem =  this.orderData.order_items.length;
    let ProductArray = [];
    let scriptProducts = '';

    this.orderData.order_items.forEach(function (value:any, key:any) {
      let productId:any = value.product_id;
      if(value.is_addon==1){
        productId = value.addon_id;
      }


      // ProductArray[key] = {
      //   'item_name': value.name,
      //   'item_id': productId,
      //   'price': value.price/value.quantity,
      //   'item_variant': value.product_variant_id,
      //   'quantity': value.quantity,
      // };

      
      scriptProducts += `
            {
              'name': '`+value.name+`',
              'id': '`+productId+`',
              'price': '`+value.price/value.quantity+`',
              'variant': '`+value.product_variant_id+`',
              'quantity': `+value.quantity+`,
              'category': 'Alloy Wheel'
            }`;
      if((key+1) !== totalItem){
        scriptProducts += `,`;
      }
    });

    // (<any>window).dataLayer.push({
    //   'event': 'purchase',
    //   'ecommerce': {
    //     'transaction_id': this.orderId,
    //     'affiliation': 'TunerStop Online Store',
    //     'value': this.orderData.total,
    //     'tax':this.orderData.vat,
    //     'coupon': this.orderData.coupon_id,
    //     'items': ProductArray
    //   }
    // });

    
    // $( "#gtagId" ).remove();
    let script = this._renderer2.createElement('script');
    script.id = "gtagId";
    script.text = `
    var dataLayer  = window.dataLayer || [];
    dataLayer.push({
      'event': 'purchase',
      'ecommerce': {
        'purchase': {
          'actionField': {
            'id': '`+this.orderId+`',
            'affiliation': 'Clockwork.app Online Store',
            'revenue': '`+this.orderData.total+`',
            'Tax':'`+this.orderData.vat+`',
            'coupon': '`+this.orderData.coupon_id+`',
            'shipping':'`+((this.orderData.shipping_amount!=undefined)?this.orderData.shipping_amount:0.00)+`'
          },
          'products': [`+scriptProducts+`]
          }
      }
    });
    `;

    $( "#googleTagManagerScript" ).before( script );
    
  }

  ngOnDestroy() {
   // this.dataService.hideHeaderFooter.next(false);
  }


}
